import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { BillingDetails } from '../../@types';

export const fetchPublicBillingDetails = async (): Promise<BillingDetails> => {
  const res = await axiosInstance.get('/api/payments/billing-details');
  return res.data;
};

export const useGetUserBillingDetailsData = () => {
  return useQuery(['fetchPublicBillingDetails'], fetchPublicBillingDetails);
};
